import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1bd206a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "Caption" }
const _hoisted_4 = {
  key: 0,
  class: "Text"
}
const _hoisted_5 = { class: "Caption" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_InlineSVG, {
      class: "LargeIcon",
      src: require(`@/assets/svg/categories/${_ctx.buildingPart.icon}.svg`)
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.buildingPart.title), 1),
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.buildingPart.texts.count.allRelated), 1)
    ]),
    (!_ctx.inResaleContext)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.buildingPart.hasOnlineTypes)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.mixWB('TONNES_2')), 1),
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.buildingPart.texts.tons.allRelated), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.buildingPart.hasOnlineTypes)
      ? (_openBlock(), _createBlock(_component_InlineSVG, {
          key: 1,
          class: "Icon",
          src: require('@/assets/svg/angle-right.svg')
        }, null, 8, ["src"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_7))
  ], 64))
}